module.exports = __webpack_public_path__ + "img/bike.cff466dc.svg";